/**
 * Visual tokens and stage labels for the DayDetails dispatch-stage pill and hover log.
 */

/** Stages that appear in history but never become the card pill / current status. */
export const HISTORY_ONLY_STAGES = new Set(["Broadcast"]);

/** Tailwind classes for the DayDetails status pill (lifecycle stages only). */
export const PILL_COLORS = {
  Draft: "bg-gray-300",
  Dispatched: "bg-blue-600 hover:bg-blue-800 text-white",
  Reviewed: "bg-green-700 hover:bg-green-900 text-white",
  Modified: "bg-yellow-500 hover:bg-yellow-700 text-white",
};

/** Draft looks inert unless there is history (e.g. Broadcast-only) to inspect. */
export const DRAFT_WITH_HISTORY_PILL = "bg-gray-300 hover:bg-gray-400";

/** Tailwind classes for stage chips inside the hover history list. */
export const CHIP_COLORS = {
  Draft: "bg-gray-300 text-gray-800",
  Dispatched: "bg-blue-600 text-white",
  Reviewed: "bg-green-700 text-white",
  Modified: "bg-yellow-500 text-white",
  Broadcast: "bg-orange-800 text-white",
};

/** Background/ring for the current lifecycle row in the hover log. */
export const CURRENT_ROW_TINT = {
  Dispatched: "bg-blue-50 ring-1 ring-blue-200",
  Reviewed: "bg-green-50 ring-1 ring-green-200",
  Modified: "bg-yellow-50 ring-1 ring-yellow-200",
};

/** Max characters of a Broadcast SMS body shown in the hover preview. */
export const BROADCAST_PREVIEW_MAX_CHARS = 100;
